import { useLocation } from 'react-router-dom';
import { en, type MsCopy } from './en';
import { zhTW } from './zh-TW';
import { msLocaleFromPath, type MsLocale } from './paths';

const COPY: Record<MsLocale, MsCopy> = { en, 'zh-TW': zhTW };

export const msCopyFor = (locale: MsLocale): MsCopy => COPY[locale];

export const useMsLocale = (): MsLocale => msLocaleFromPath(useLocation().pathname);

export const useMsCopy = (): MsCopy => msCopyFor(useMsLocale());

export type { MsCopy, MsLegalDoc, MsLegalSection } from './en';
export * from './paths';
